import { css } from "@emotion/css";
import {
  ButtonGroup,
  GhostButton,
  PrimaryButton,
  Space,
} from "@certn/cascadia";
import { CascadiaJsonFormContext } from "@certn/forms";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { KonfirVerificationStatus } from "./types";
import { useApplication } from "../../ApplicationContext";
import { deriveStateFromKonfirStatus } from "./helpers";

type EmploymentVerificationNavigationProps = {
  status: KonfirVerificationStatus | null;
  onStartClick: () => void;
  isStarting: boolean;
};

export const EmploymentVerificationNavigation = ({
  status,
  onStartClick,
  isStarting,
}: EmploymentVerificationNavigationProps) => {
  const { t } = useTranslation();
  const { navigateToSection, prevSection } = useApplication();
  const { isSubmitting } = useContext(CascadiaJsonFormContext);

  const { isComplete, isRecoverable, isSkipped } =
    deriveStateFromKonfirStatus(status);

  return (
    <div
      className={css({
        paddingTop: "calc(var(--space-4) - 1px)",
        paddingBottom: "var(--space-4)",
        marginTop: "var(--space-5)",
        borderTop: "1px solid var(--border-base)",
      })}
    >
      <ButtonGroup>
        {prevSection && (
          <GhostButton
            testID="section-back-button"
            leftIcon="chevron_left"
            onPress={() => navigateToSection(prevSection)}
          >
            {t("Back")}
          </GhostButton>
        )}
        <Space />
        {isComplete || isSkipped ? (
          <PrimaryButton
            testID="section-next-step-button"
            type="submit"
            isLoading={isSubmitting}
          >
            {t("Next step")}
          </PrimaryButton>
        ) : (
          <PrimaryButton
            testID="konfir-verify-button"
            onPress={onStartClick}
            isDisabled={isStarting}
          >
            {isRecoverable ? t("Retry verification") : t("Start verification")}
          </PrimaryButton>
        )}
      </ButtonGroup>
    </div>
  );
};
